import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react-markdown/lib/react-markdown';

import './Information.scss';

interface InformationProps {
  text: string;
  children: ReactNode;
  iconClassName?: string;
}

function Information({ text, children, iconClassName = '' }: InformationProps) {
  return (
    <div className="information-container">
      {children}
      <div>
        <div className="information-button-container">
          <div className="information-button-information-display">
            <div className="information-button-text">{text}</div>
            <div className="information-button-triangle" />
          </div>
          <FontAwesomeIcon className={iconClassName} icon={faInfoCircle} />
        </div>
      </div>
    </div>
  );
}

export default Information;
